import React, { useCallback, useMemo } from 'react';
import { Tooltip } from '@material-ui/core';
import { translate } from '../Services/translation';
import {
  CloudRain,
  Package,
  Trash,
  GasPump,
  SpeakerHigh,
  ArrowsLeftRight,
} from 'phosphor-react';
import BuyButton from './BuyButton';
import QuantityInput from './QuantityInput';
import CopyButton from './CopyButton';
import colors from 'Exports/colors.scss';
import ProductPriceModel from './ProductPriceModel';
import ProductInStockTag from './ProductInStockTag';
import { dataLayerSelectItem } from '../Services/Gtm.service';

const ProductsViewListItemSlim = (props) => {
  const {
    product,
    showBuyButton,
    showComparisonButton,
    showAddToOffer,
  } = props;
  const onSelectItem = () => dataLayerSelectItem(product.gtmProduct);

  const images = product.images ?? [];
  const imageData = product.imageData ?? [];

  return (
    <li className="product-list-card-slim">
      <div className="product-list-card-slim__wrapper">
        <div className="product-list-card-slim__images">
          {product.brandLogoUrl && !product.hideBrandInfoInListings ? (
            <img src={product.brandLogoUrl} loading="lazy" />
          ) : null}
          <img src={imageData[0]?.url ?? images[0]} alt={imageData[0]?.alt || product.baseProductName} loading="lazy" />
          <div className="product-list-card-slim__environment-icons">
            {product.threePeakMountainSF && (
              <Tooltip title={translate('product.tooltip.snow')}>
                <img src="/ui/images/snowForSnowAndIce.svg" loading="lazy" />
              </Tooltip>
            )}
            {product.nordicFriction && (
              <Tooltip title={translate('product.tooltip.ice')}>
                <img src="/ui/images/IceMountain.svg" loading="lazy" />
              </Tooltip>
            )}
          </div>
          {product.msMark && (
            <div className="product-list-card__left--ms ms-icon">
              <Tooltip title={translate('product.tooltip.m-s')}>
                <span>M + S</span>
              </Tooltip>
            </div>
          )}
          <div>
            <div className="product-list-card__left--tags">
              {product.tags &&
                product.tags.map((tag) => (
                  <span key={tag.text + product.id} className="product-tag" style={{backgroundColor:tag.color}}>
                    {tag.text}
                  </span>
                ))}
            </div>
          </div>
        </div>
        <div className="product-list-card-slim__information-container">
          <div className="product-list-card-slim__information">
            <div className="product-list-card-slim__text">
              <span className="product__info--art-nr">
                <span>{product.id}</span>
                <CopyButton text={product.id} />
              </span>
              <a href={product.url} onClick={onSelectItem}>
                <h3 className="product-list-card-slim__header">
                  {!product.hideBrandInfoInListings && product.brand}{' '}
                  {product.baseProductName}
                </h3>
              </a>
              <span>{product.name}</span>
              <div className="product-list-card__middle--enviroment">
                {product.fuelClass && (
                  <span className="enviroment-icon">
                    <GasPump size={20} />
                    {product.fuelClass}
                  </span>
                )}
                {product.wetGrip && (
                  <span className="enviroment-icon">
                    <CloudRain size={20} />
                    {product.wetGrip}
                  </span>
                )}
                {product.db && (
                  <span className="enviroment-icon">
                    <SpeakerHigh size={20} />
                    {product.noiseWavesNW} / {product.db}
                  </span>
                )}
              </div>
            </div>
            <div className="product-list-card-slim__price">
              {product.productPriceModel && (
                <ProductPriceModel {...product.productPriceModel} />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="product-list-card-slim__information-subcontainer">
        <div className="product-list-card-slim__information product-list-card-slim__information--footer">
          <div className="product-list-card-slim__footer-tags">
            <ProductInStockTag {...product} />
          </div>
          <div className="product-list-card-slim__buy-button push">
            <BuyButton
              quantity={product.quantity}
              articleNumber={product.id}
              quantityFieldId={product.quantityFieldId}
              label={
                product.showBuyButton
                  ? translate('product.add-to-cart')
                  : product.userIsAuthenticated
                  ? translate('product.show-product')
                  : translate('product.login-to-proceed')
              }
              disabled={!product.userIsAuthenticated || !product.showBuyButton}
              userIsAuthenticated={product.userIsAuthenticated}
              href={product.url}
            />
          </div>
        </div>
      </div>
    </li>
  );
};

export default ProductsViewListItemSlim;
